import axios from '../axiosConfig';
import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import MainEmpresas from '../components/MainEmpresas';
import Modal from '../components/Modal';
import ModalCodigo from '../components/ModalCodigo';
import ModalPerfil from '../components/ModalPerfil';
import ModalRecuperar from '../components/ModalRecuperar';
import NavBar from '../components/NavBar';
import { handleError, toastError } from '../funciones';
import { Tutorial } from '../components/Tutorial';

function Empresas() {

    const [perfil, setPerfil] = useState({ rubros: [], rubrosSinFormato: [], productosOfrecidos: [], productosDemandados: [], representantes: [], notificaciones: [], nombre: '' });

    useEffect(() => {

        const params = {
            params: {
                id: localStorage.getItem(process.env.REACT_APP_ID_EMPRESA)
            }
        }

        axios.get(process.env.REACT_APP_URL + "empresa/perfil", params)
            .then(function (response) {
                setPerfil(response.data);
            })
            .catch(function (error) {
                toastError(handleError(error))
            });
        document.getElementById("ofertaDemanda").classList.remove("d-none");
        document.getElementById("datosRepresentante").classList.remove("d-none");

    }, [])

    return (
        <>
            <NavBar notificaciones={perfil.notificaciones} ultimaVez={perfil.ultimaVez} logo={perfil.rubroUrl} />
            <MainEmpresas />
            <Footer />
            <Modal />
            {/*<Loader/>*/}
            <ModalPerfil perfil={perfil} isEditar={true} setPerfil={setPerfil} />
            <ModalCodigo />
            <ModalRecuperar />
            <Tutorial initialId={5} />
        </>
    );
}


export default Empresas;